import { render } from "./PlatformQuickCreateModal.vue?vue&type=template&id=a80edcf8&scoped=true"
import script from "./PlatformQuickCreateModal.vue?vue&type=script&lang=js"
export * from "./PlatformQuickCreateModal.vue?vue&type=script&lang=js"

import "./PlatformQuickCreateModal.vue?vue&type=style&index=0&id=a80edcf8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a80edcf8"]])

export default __exports__